import { render, staticRenderFns } from "./ReloadSmallSvg.vue?vue&type=template&id=37befd2f&"
import script from "./ReloadSmallSvg.vue?vue&type=script&lang=js&"
export * from "./ReloadSmallSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports